import React from "react";
import type { SrNameCandidate } from "./sr-name-candidate-types";
import { selectionMessage } from "./sr-name-candidate-types";

type Props = {
    candidates?: SrNameCandidate[];
    disabled?: boolean;
    onPick?: (text: string) => void;
};

export const SrNameCandidates: React.FC<Props> = ({
    candidates,
    disabled,
    onPick,
}) => {
    if (!candidates?.length || !onPick) return null;

    return (
        <div className="sr-chat-name-picks mt-2 space-y-1.5">
            <p className="text-xs font-medium text-slate-500">
                Select a person to see their requests
            </p>
            {candidates.map((c) => {
                const meta = [c.village, c.mobile, c.request_count != null ? `${c.request_count} requests` : ""]
                    .filter(Boolean)
                    .join(" · ");
                return (
                    <button
                        key={c.subject_id}
                        type="button"
                        disabled={disabled}
                        onClick={() => onPick(selectionMessage(c))}
                        className="flex w-full flex-col rounded-xl border border-slate-200 bg-white px-3 py-2 text-left shadow-sm transition hover:border-[#3A80F4]/50 hover:bg-[#3A80F4]/5 disabled:opacity-50"
                    >
                        <span className="text-sm font-semibold text-slate-800">
                            {c.name}
                        </span>
                        {meta ? (
                            <span className="text-xs text-slate-500">{meta}</span>
                        ) : null}
                    </button>
                );
            })}
        </div>
    );
};
